import { IReceptionCaseSearch, IReceptionCaseSearchCondition, ILabel } from '@blcloud/bl-datamodel';

/** 検索条件インターフェース定義 */
export interface ISearchCondition extends IReceptionCaseSearchCondition {
  todayFlag?: boolean;
  showDelete?: boolean;
  searchTargetDateType?: string;
}

/** 検索結果インターフェース定義 */
export interface ISearchResult extends IReceptionCaseSearch {
  /** 顧客名称 */
  customerName?: string;
  /** 顧客名称カナ */
  customerNameKana?: string;
  /** 車両登録番号 */
  plateNo?: string;
  /** ラベル */
  labelList?: { value: string[]; labelUseCategory: string; master: ILabel[] };
  /** 受付管理組織名称 */
  receptOrganizationName?: string;
  // /** 証跡 */
  // existEvidence?: string;
  /** 希望日時 */
  visitStartDateTime: string;
  /** 引取日時 */
  takeOverDateTime: string;
  /** 納車日時 */
  vehicleDeliveryStartTime: string;
  /** 表示用受付番号 */
  displayReceptionNum?: string;
  /** 案件有無 */
  existCase?: string;
  /** 代車利用 */
  replacementVehicle?: string;
}

/**
 * 検索対象日時
 */
export enum SearchTargetDateType {
  /* 希望日時 */
  Desired = 'desired',
  /** 入庫日時 */
  TakeOver = 'takeover',
  /** 入庫日時＋希望日時 */
  TakeOverAndDesired = 'takeover_and_desired',
  /** 受付日 */
  Reception = 'reception',
  /** 案件開始日 */
  CaseStart = 'caseStart',
  /** 入庫期間 */
  TakeOverPeriod = 'takeOverPeriod',
  /** 入庫期間＋希望日時 */
  TakeOverPeriodAndDesired = 'takeOverPeriod_and_desired',
  /** 引取日時 */
  TakeOverDateTime = 'takeOverDateTime',
}

export const SearchTargetDateTypeArray = [
  { code: SearchTargetDateType.TakeOverAndDesired, name: '入庫日時, 希望日時' },
  { code: SearchTargetDateType.TakeOverPeriodAndDesired, name: '入庫期間, 希望日時' },
  { code: SearchTargetDateType.Desired, name: '希望日時' },
  { code: SearchTargetDateType.TakeOver, name: '入庫日時' },
  { code: SearchTargetDateType.TakeOverPeriod, name: '入庫期間' },
  { code: SearchTargetDateType.TakeOverDateTime, name: '引取日時' },
  { code: SearchTargetDateType.Reception, name: '受付日' },
  // 未受付の機能ができるまで非表示
  // { code: SearchTargetDateType.CaseStart, name: '案件依頼日' },
];

// 機能ができるまで未使用
export const ExistEvidenceModeArray = [
  { text: '', value: '0' },
  { text: '証跡有りのみ', value: '1' },
  { text: '証跡無しのみ', value: '2' },
];



// WEBPACK FOOTER //
// ./src/app/page/recept-list-page/recept-list/recept-list.interface.ts